import Cookies from "js-cookie";

export default class CookiesService {
  static getUserData() {
    try {
      const userData = Cookies.get('user_data');
      return userData ? JSON.parse(userData) : {}
    } catch (e) {
      console.error('Error parsing user_data cookie:', e);
      return null;
    }
  }

  static getUserSupplierPitagoras() {
    try {
      const supplierPitagoras = Cookies.get('supplier_pitagoras');
      return supplierPitagoras ? JSON.parse(supplierPitagoras) : null
    } catch (e) {
      console.error('Error parsing supplier_pitagoras cookie:', e);
      return null;
    }
  }

  static setUserSupplierPitagoras(data) {
    try {
      const stringifiedData = JSON.stringify(data);
      Cookies.set('supplier_pitagoras', stringifiedData, { 
        path: '/' 
      });
    } catch (e) {
      console.error('Error stringifying or setting supplier_pitagoras cookie:', e);
    }
  }

  static get(key) {
    if (process.env.REACT_APP_IS_DEBUG_MODE) return null;
    const userData = this.getUserData();
    return userData ? userData[key] : null;
  }

  static getUserLogin() {
    if (process.env.REACT_APP_IS_DEBUG_MODE) return 'teste.desenv';
    const userData = this.getUserData();
    return userData ? userData.login : null;
  }

  static getUserId() {
    if (process.env.REACT_APP_IS_DEBUG_MODE) return 6666;
    const userData = this.getUserData();
    return userData ? userData.id_usuario : null;
  }

  static isUserAdmin() {
    if (process.env.REACT_APP_IS_DEBUG_MODE) return true;
    const userData = this.getUserData();
    return userData ? userData.admin : false;
  }

  static getAcessos() {
    if (process.env.REACT_APP_IS_DEBUG_MODE) return { pa_revisao_priorizar: true };
    const userData = this.getUserData();
    return userData ? userData.acessos : {};
  }
}
